import { tagMap } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

import AverageDecksPage from '.'

export const getServerSideProps = async (context: any) => {
  const subDirs = context.query.slug.map((slug: string) =>
    slug in tagMap ? tagMap[slug as keyof typeof tagMap] : slug,
  )
  const resolvedUrl = subDirs.length > 0 ? `/${subDirs.join('/')}` : ''
  const url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/average-decks/${context.query.commander}${resolvedUrl}.json`
  return serverSidePropsFor(url)
}

export default AverageDecksPage
